import DashboardsList from './DashboardsList';
import { DashboardsGrid } from './DashboardsList.styles';

export default DashboardsList;
export { DashboardsGrid };
